export const API_URLS_COMMON = {
  LOGIN: "User/Login",
  FORGOT_PASSWORD: "User/ForgotPassword",
  VALIDATE_RESET_PASSWORD_LINK: "User/ValidateResetPasswordLink",
  RESET_PASSWORD: "User/ResetPassword",
  TOKEN_INFO: "User/TokenInfo",
  GET_USER: "User/$id",

  COMPANY: "Company",
  LOCATION: "Location",
  USER: "User",
  RELEASE_NOTES: "ReleaseNotes",

  // Permissions
  GET_APP_PERMISSIONS: "RolePermission/Mine",

  // location
  GET_LOCATION_COMPANY: "Company/Names/Dropdown/ByLocationEntityType",
  GET_LOCATION_STATUS: "Company/Lookup/Status",
  GET_LOCATION_WAND_TYPE: "Lookup/Group/$groupName",
  GET_SENSE_LOCATIONS_BY_COMPANY: "Location/Names",

  // company
  GET_COMPANY: "Company/$companyId",
  GET_COUNTRIES: "Country/Names",
  GET_STATES: "State/Names",
  GET_CITIES: "City/Names",
  GET_ACTIVE_SENSE_COMPANIES: "Company/Names",

  // User
  GET_EMAIL_ADDRESSES: "ADUser",
  GET_USER_STATUS: "User/Lookup/Status",
  GET_USER_ROLES: "Role/Roles",
  GET_APPLICATIONS: "Application",
  GET_ROLES: "Role/Roles",
  LOCATION_NAMES: "Location/Names",
  COMPANY_NAMES: "Company/Names",
  POST_USER: "User",
  PUT_USER: "User/$id",
  GET_USER_DETAIL: "User/$id",
  SIGNUP_USER: "User/SignUp",
  VALIDATE_OFFER_CODE: "OfferCode/validate",

  // Export User
  EXPORT_USER: "User/Export",

  // Resend Email
  RESEND_EMAIL: "User/ForgotPassword",

  //Settings
  SETTING_UPDATE_PROFILE: "User/Settings/UpdateProfile",
  SETTING_CHANGE_PASSWORD: "User/ChangePassword",
  SETTING_UPDATE_PREFERENCE: "User/Settings/UpdatePreference",
  GET_PREFERENCE: "User/Settings/GetPreference",

  // Advance
  GET_ADVANCE_SATELLITE: "Advance/Satellites/Names",
  GET_ADVANCE_LABS: "Advance/labs/Names",
  GET_ADVANCE_COMPANIES: "Advance/Companies/Names",
  // Network
  GET_NETWORK_LOCATIONS: "Network/Locations/Names",
  GET_NETWORK_COMPANIES: "Network/Companies/Names",

  //Animal
  UPDATE_STATUS:'Animal/UpdateStatus',
  UPDATE_ANIMAL_DATA: "Animal/UpdateAnimalData",
  ADD_UPDATE_VISUAL_TAG: "Animal/AddUpdateVisualTag",
  ADD_UPDATE_CHUTE_WEIGHTS: "ChuteWeight/AddUpdateChuteWeights",

  UPDATE_USER_ASSIGNED_LOCATIONS: "UserPreferenceLocations/$id",
  GET_USERS_PREFERENCE_LOCATIONS: "UserPreferenceLocations",
  GET_USER_PREFERENCE_LOCATIONS: "UserPreferenceLocations/$id",
  UPDATE_USER_PREFERENCE_LOCATIONS: "UserPreferenceLocations",

  // Release Notes
  GET_RELEASE_NOTES: "ReleaseNotes",
  CREATE_RELEASE_NOTE: "ReleaseNotes",
  GET_RELEASE_NOTE: "ReleaseNotes/$id",
  UPDATE_RELEASE_NOTE: "ReleaseNotes/$id",
  DELETE_RELEASE_NOTE: "ReleaseNotes/$id",
};
